<div class="container-fluid main">
    <div class="row" style="height: 100%;">
        <div style="z-index : 10;position: absolute;" class="col-12">
            <!-- <img src={{loginDetails.backgroundImg}} alt="login" class="login" height="635" style="width: inherit;filter: blur(16px);
      -webkit-filter: blur(16px);" width="1340"> -->
        </div>
        <div class="d-flex form loginContainer" style="z-index : 100;">
            <div class="card loginDialog p-2">
                <div class="card-body">
                    <div class="text-center mb-4" *ngIf="loginDetails?.companyLogo">

                        <img src="{{loginDetails.companyLogo}}" alt="" width="50" height="50" class="text-center">
                    </div>

                    <h5 class="text-center" *ngIf="loginDetails?.companyText">{{loginDetails.companyText}}</h5>
                    <div class="row">
                        <div class="col-12 d-flex justify-content-between">
                            <!-- <h3 *ngIf="!loginAsCSE">{{loginDetails.title}}</h3>
                            <h3 *ngIf="loginAsCSE">Login As Admin/CSE</h3> -->
                            <h3>{{roleName}}</h3>
                            <div class="mt-1" style="cursor: pointer;" (click)="locationBack()">
                                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M6.99999 5.58599L11.95 0.635986L13.364 2.04999L8.41399 6.99999L13.364 11.95L11.95 13.364L6.99999 8.41399L2.04999 13.364L0.635986 11.95L5.58599 6.99999L0.635986 2.04999L2.04999 0.635986L6.99999 5.58599Z" fill="#111111"/>
                                    </svg>
                            </div>
                        </div>
                        <!-- <div class="col-2 text-end">
                            <button type="button" (click)="close();" style="background: none;border:none;"><span
                                    style='font-size:25px;'>&#10005;</span></button>
                        </div> -->
                    </div>

                    <form [formGroup]="dynamicForm!" (ngSubmit)="onSubmit()" novalidate>
                        <div *ngFor="let controls of formFields" class="mt-3">
                            <label *ngIf="!loginDetails?.companyText" class="d-none">{{controls?.label}}</label>
                            <div style="margin-top: -19px;">
                                <span style="padding-left: 13px;">
                                    <!-- <i style="color:#BFBFBF;font-size:20px;position: absolute;
              top: 37px;" [ngClass]="controls?.placeholderIcon"></i> -->

                                    <div style="position:relative;">
                                        <i class="fas fa-user-alt" *ngIf="controls?.label == 'username'"
                                            style="color:#BFBFBF; font-size:22px; position: absolute; top: 12px; left:15px"></i>

                                        <i class="fa fa-lock" *ngIf="controls?.label == 'password'"
                                            style="color:#BFBFBF; font-size:26px; position: absolute;top: 10px; left:16px"></i>

                                        <!-- <svg  *ngIf="controls?.label == 'password'" xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 96 960 960"
                                            width="48">
                                            <path
                                                d="M220 976q-24.75 0-42.375-17.625T160 916V482q0-24.75 17.625-42.375T220 422h70v-96q0-78.85 55.606-134.425Q401.212 136 480.106 136T614.5 191.575Q670 247.15 670 326v96h70q24.75 0 42.375 17.625T800 482v434q0 24.75-17.625 42.375T740 976H220Zm0-60h520V482H220v434Zm260.168-140Q512 776 534.5 753.969T557 701q0-30-22.668-54.5t-54.5-24.5Q448 622 425.5 646.5t-22.5 55q0 30.5 22.668 52.5t54.5 22ZM350 422h260v-96q0-54.167-37.882-92.083-37.883-37.917-92-37.917Q426 196 388 233.917 350 271.833 350 326v96ZM220 916V482v434Z" />
                                        </svg> -->

                                        <input [type]="show ?  'text' : controls?.type"
                                            [formControlName]="controls?.label" class="form-control loginUserInput"
                                            placeholder={{controls?.placeholder}} />

                                        <span class="showIcon" *ngIf="controls?.showHide == 'yes'">
                                            <span>
                                                <!-- {{showHideText}} -->
                                                <i class="fa fa-eye" *ngIf="show" (click)="password()"
                                                    style="color:#ED1556"></i>
                                                <i class="fa fa-eye-slash" *ngIf="!show" (click)="password()"
                                                    style="color:#ED1556"></i>

                                            </span>
                                        </span>
                                    </div>
                                </span>
                            </div>

                            <div *ngFor="let validation of controls.validations">
                                <span
                                    *ngIf="dynamicForm.controls[controls.label].touched && dynamicForm.controls[controls.label].errors">
                                    <p *ngIf="dynamicForm.controls[controls.label].errors[validation.name]"
                                        class="text-danger">
                                        {{validation.message}}
                                    </p>
                                </span>
                            </div>

                        </div>
                        <div class="row mt-4" *ngIf="loginDetails?.captchaText == 'yes'">
                            <div class="col">
                                <div class="security-captcha d-flex justify-content-between">
                                    <div class="d-flex">
                                        <!-- placeholder="Enter Captcha"
                            formControlName="captcha" -->
                                        <div class="form-group">
                                            <label class=" my-1" for="captcha my-1">Security Code</label>
                                            <input autocomplete="off" type="captcha" class="form-control" id="captcha"
                                                aria-describedby="userHelp" formControlName="captchaText"
                                                name="captchaText" />
                                        </div>
                                        <span class="ms-4" style="background: #E8F0FE">
                                            <img [src]="imageCaptcha" alt="">

                                        </span>
                                        <span class="ms-4" style="margin-top: 34px;cursor: pointer;">
                                            <i class="fa fa-refresh" (click)="refreshCaptcha()"></i>
                                        </span>
                                    </div>

                                </div>
                            </div>
                        </div>


                        <div class="mt-2 text-end mb-3" *ngIf="loginDetails?.forgotPassword =='yes'">
                            <!-- <a routerLink="/forgot-password">Forgot password?</a> -->
                            <a (click)="forgotPassword()" class="signup"
                                style="text-decoration: none !important;">Forgot Password?</a>
                        </div>
                        <div class="mt-2 text-end" *ngIf="loginDetails?.signUp =='yes'">
                            <a (click)="signUp()" class="signup">Sign Up ?</a>
                            <!-- <a (click)="forgotPassword()" (forgotData)="receiveData($event)">Forgot password ?</a> -->
                        </div>


                        <div [ngClass]="loginAsCSE ? 'text-center' : 'text-center'">
                            <input type="submit" class="btn btn-primary loginUserInput"
                                style="background-color: #ED1556; width:100%" value="LOGIN"
                                [disabled]="!dynamicForm.valid" />
                        </div>
                        <div class="text-center" *ngIf="loginDetails?.coprightText">
                            <p>{{loginDetails.coprightText}}</p>
                        </div>
                        <!-- <p *ngIf="!loginAsCSE" class="horizontal mt-3"><span>Or</span></p> -->
                        <!-- <p class="horizontal mt-3"><span>Or</span></p> -->

                        <!-- <div *ngIf="!loginAsCSE" class="text-center mt-3 mb-4">
                            <input type="button" class="btn btn-primary loginUserInput" (click)="loginAsCSEClicked()"
                                style="background-color: white;border: 1px solid #ED1556;width: -webkit-fill-available;color:#ED1556"
                                value="LOGIN AS ADMIN / CSE" />
                        </div>

                        <div *ngIf="loginAsCSE" class="text-center mt-3 mb-4">
                            <input type="button" class="btn btn-primary loginUserInput"
                                (click)="loginAsFacilityClicked()"
                                style="background-color: white;border: 1px solid #ED1556;width: -webkit-fill-available;color:#ED1556"
                                value="LOGIN AS FACILITY" />
                        </div> -->

                    </form>
                </div>
            </div>
        </div>

    </div>

    
</div>